import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class StatementLCP {

	private memberBase: any = new memberPortal();
	
	initTables(): any {
		createDropdown();
	}

	dropdownVal(): any {
		$("#members-statement-period-select").change(function() {
			$(this).parent().find('label').addClass("input-filled")
			callAjax(1,$('option:selected', this).val());
		});
	}
	
}

function createDropdown(){
	const currentDate = new Date();
	var selCat =$("#members-statement-period-select").selectize();
	for (var i=0; i<6; i++) {
		const currentMonthYear = currentDate.toLocaleString('default', { month: 'long' }) + " " + currentDate.getFullYear();
		var monthVal = ((currentDate.getMonth()+1) > 9 ) ? (currentDate.getMonth()+1) : ("0" + (currentDate.getMonth()+1)) ;
		var valueOfDrop = currentDate.getFullYear()+"-"+monthVal+"-01";
		currentDate.setMonth(currentDate.getMonth()-1);
		selCat[0].selectize.addOption({value:valueOfDrop,text:currentMonthYear});
	}
	
}


function callAjax(currentPageNumber: number, selectionCategory: any) { 
	if(location.host == "localhost:5000"){
		$.ajax({
			type: 'GET',
			url: 'http://localhost:5000/dummy-data/statements.JSON',
			contentType: 'application/json',
			success: function (data: any) {
				//$("#transaction").removeClass("disable_html");
				createTable(data.jsonDataArray);
				createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}else{ 
		var data_obj = "pageOffset=" + currentPageNumber + "&date=" + selectionCategory;
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/getStatementLCP',
			data: data_obj,
			contentType: 'application/json',
			success: function (data: any) {
				$("#transaction").removeClass("disable_html");
				$("#claim-submission-status").addClass("disable_html");
				createTable(data.jsonDataArray);
				createPagination(currentPageNumber, data.numberOfPages);
			},
			error: function (error: any) {
			}
		});

	}
	
}

function undefinedCheck(varVal: any) {
	if (typeof varVal === "undefined") {
		return "";
	}
	else {
		return varVal;
	}
}

function createPagination(currentPage:any,numberOfPages:any){

			 if(currentPage < 10 && numberOfPages >= 10)
			 {
				paginationHTML(currentPage,1,10,numberOfPages);
			 }else
			 if(currentPage <= 10 && numberOfPages <= 10)
			 {
				paginationHTML(currentPage,1,numberOfPages,numberOfPages);
			 }else
			 if(currentPage >= 10 && numberOfPages <= (parseInt(currentPage)+5)){
				paginationHTML(currentPage, (parseInt(numberOfPages)-10),numberOfPages, numberOfPages);
			 }else
			 if(currentPage >= 10 && numberOfPages >= (parseInt(currentPage)+5)){
				paginationHTML(currentPage, (parseInt(currentPage)-5),currentPage+5, numberOfPages);
			 }
	 }


function createTable(jsonDataArrayStr: any) {

	var jsonDataArray = JSON.parse(jsonDataArrayStr);

		let benefitsTable = $('#DataTables_Table_DatasetStatement');
		benefitsTable.dataTable().fnClearTable();
		benefitsTable.dataTable().fnDestroy();

		let dataSet = jsonDataArray;
		let tableOptions = {
			data: dataSet,
			"paging":   false,
			// "ordering": false,
			"info":     false,
			"columns": [
				// { "data": "type" },
				{ "data": "activity_date" },
				{ "data": "description" },
				{ "data": "benefits" },
				{ "data": "award_points" },
				{ "data": "tier_points" }
			]
			// "columnDefs": [
			//   { "width": "300px", "targets": 3 }
			// ]

		  }
		
		let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);
		
}

function paginationHTML(currentPage: any, startPage: any, lastPage: any, numberOfPages:any) {
	var paginationHTML = "";
	if(currentPage == 1){
		paginationHTML += '<a class="paginate_button paginate_button_statement  previous disabled" aria-controls="DataTables_Table_0"  data-dt-idx="' +  (parseInt(currentPage)) + '" id="DataTables_Table_0_next">Previous</a><span>';
	}else{
		paginationHTML += '<a class="paginate_button paginate_button_statement  previous" aria-controls="DataTables_Table_0" data-dt-idx="' +  (parseInt(currentPage)- 1) + '" tabindex="0" id="DataTables_Table_0_next">Previous</a><span>';
	}
	for (var i = startPage; i <= lastPage; i++) {
		if (i == currentPage) {
			paginationHTML += '<a class="paginate_button paginate_button_statement  current" aria-controls="DataTables_Table_0"  data-dt-idx="' + i + '" tabindex="0"> ' + i + '</a>';
		} else {
			paginationHTML += '<a class="paginate_button paginate_button_statement " aria-controls="DataTables_Table_0"  data-dt-idx="' + i + '" tabindex="0"> ' + i + '</a>';
		}
	}
	if(numberOfPages == currentPage){
		paginationHTML += '</span><a class="paginate_button paginate_button_statement  next disabled" aria-controls="DataTables_Table_0" data-dt-idx="' + (parseInt(currentPage)) + '" tabindex="0" id="DataTables_Table_0_next">Next</a>';
	}
	else{
		paginationHTML += '</span><a class="paginate_button paginate_button_statement  next" aria-controls="DataTables_Table_0" data-dt-idx="' + (parseInt(currentPage) + 1) + '" tabindex="0" id="DataTables_Table_0_next">Next</a>';
	}
	
	$(".dataTables_paginate_statements").html(paginationHTML);

	$(".paginate_button_statement").on("click", function(){
		callAjax($(this).data("dt-idx"),$("#members-statement-period-select").val());
	});

}

// let benefitsDataTable:any = benefitsTable.dataTable(tableOptions);


function myStatements(id:any){
	callAjax(id);
}


let scope: Element = document.querySelector('.miles-statement-account');

if (scope) {
	try {
		let statementLCP = new StatementLCP();
		statementLCP.initTables();
		statementLCP.dropdownVal();
	} catch (e) {  /*console.error(e); */ }
	
}
